import '@take-2/fd-modules/movie/reviews/desktop.app';
